<template>
    <div class="inline-flex overflow-hidden rounded-lg border border-baseColor"
         role="radiogroup" aria-label="Единицы измерения">
        <button :class="modelValue==='m' ? activeClass : inactiveClass"
                class="px-3 py-1.5 text-sm text-nowrap focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 transition"
                :aria-checked="modelValue==='m'" role="radio"
                :disabled="disabledM"
                @click="select('m')"
                @keydown.left.prevent="select('m')">
            {{ labels.m }}
        </button>

        <button :class="modelValue==='t' ? activeClass : inactiveClass"
                class="px-3 py-1.5 text-sm text-nowrap focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 transition disabled:cursor-not-allowed disabled:bg-gray-200"
                :aria-checked="modelValue==='t'" role="radio"
                :disabled="disabledT"
                @click="select('t')"
                @keydown.right.prevent="select('t')">
            {{ labels.t }}
        </button>
    </div>
</template>

<script>
export default {
    name: "CartUnitSwitch",
    props: {
        modelValue: {type: String, default: "m"},          // 'm' | 't'
        disabledM: {type: Boolean, default: false},
        disabledT: {type: Boolean, default: false},
        labels: {
            type: Object,
            default: () => ({m: "₽ / метр", t: "₽ / тонна"}),
        },
        activeClass: {type: String, default: "bg-baseColor text-white"},
        inactiveClass: {type: String, default: "text-gray-700 hover:bg-gray-100"},
    },
    emits: ["update:modelValue", "change"],
    methods: {
        select(unit) {
            if ((unit === 'm' && this.disabledM) || (unit === 't' && this.disabledT)) return;
            if (unit !== this.modelValue) {
                this.$emit("update:modelValue", unit);
                this.$emit("change", unit);
            }
        },
    },
};
</script>
